import React from 'react';
import { Star, Plus } from 'lucide-react';
import { Button } from './ui/button';
import { Card, CardContent } from './ui/card';
import { useTranslation } from '../hooks/useTranslation';

const FeaturedSection = ({ items, onAddToCart }) => {
  const { t } = useTranslation();
  
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-2 bg-black text-white text-sm font-medium tracking-wide rounded-full mb-4">
            {t('bestSellers')}
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-black mb-4">
            {t('featuredTitle')}
          </h2>
          <p className="text-gray-600 text-lg max-w-2xl mx-auto">
            {t('featuredDescription')}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {items.map((item, index) => (
            <Card
              key={item.id}
              className="group overflow-hidden border-2 border-gray-200 hover:border-black transition-all duration-300 hover:shadow-2xl transform hover:-translate-y-2"
              style={{ animationDelay: `${index * 100}ms` }}
            >
              <div className="relative overflow-hidden aspect-square">
                <img
                  src={item.image}
                  alt={item.name}
                  className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute top-4 right-4 bg-white text-black px-3 py-1 rounded-full flex items-center space-x-1 font-semibold shadow-lg">
                  <Star className="w-4 h-4 fill-black" />
                  <span className="text-sm">{t('popular')}</span>
                </div>
              </div>
              <CardContent className="p-6">
                <h3 className="text-xl font-bold text-black mb-2 group-hover:text-gray-700 transition-colors">
                  {item.name}
                </h3>
                <p className="text-gray-600 text-sm mb-4 line-clamp-2">
                  {item.description}
                </p>
                <div className="flex items-center justify-between">
                  <span className="text-2xl font-bold text-black">
                    ${item.price.toFixed(2)}
                  </span>
                  <Button
                    onClick={() => onAddToCart(item)}
                    size="icon"
                    className="bg-black text-white hover:bg-gray-800 rounded-full w-10 h-10 transition-all duration-300 transform hover:scale-110"
                  >
                    <Plus className="w-5 h-5" />
                  </Button>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturedSection;